import { Button } from 'components/Blocks';

import { actions, ClientBilling } from 'entities';

import { useClient } from '../OptionsContext';
import { useSingleConfirmation } from 'providers/Confirmation';

interface SyncClientBillingProps {
  children?: never;
  save: (info: ClientBilling) => void;
}

function SyncClientBilling({ save }: SyncClientBillingProps): JSX.Element {
  const { selectedClient } = useClient();

  const syncBilling = actions.clients.syncClientBilling.use({
    onSuccess: save,
  });

  const onSyncClick = useSingleConfirmation({
    title: 'Sync Billing Info with Sample?',

    type: 'normal',

    text: 'This will overwrite current info with whatever info we have on Sample',

    onConfirm: async () => {
      syncBilling.execute({ id: selectedClient?.id as string });
    },
  });

  return (
    <Button loading={syncBilling.loading} onClick={onSyncClick}>
      Sync
    </Button>
  );
}

export default SyncClientBilling;
